import { Vector3 } from '@babylonjs/core';
import { ObstacleDistributionConfig } from '../ObstacleGenerator';
import { ObstacleBehavior } from './ObstacleBehavior';

export class ObstacleRotateBehavior extends ObstacleBehavior {
  constructor(startPosition: Vector3, pathIndex: number, config: ObstacleDistributionConfig) {
    super('obstacleRotate', startPosition, pathIndex, config);
  }
  update(deltaTime: number): void {
    this.mesh.rotation.y += this.config.speed * deltaTime;
  }

  clone(): ObstacleRotateBehavior {
    return new ObstacleRotateBehavior(this.startPosition, this.pathIndex, this.config);
  }
}
